<div class="progress">
  @if (!transactionStates) {
    <mat-progress-bar
      value="percentage"
      [mode]="mode"></mat-progress-bar>
  }
  @for (transactionState of transactionStates; track transactionState) {
    <div class="target-view">
      <p>
        {{ transactionState?.processTitle || transactionState?.processType }}:
        {{ transactionState?.state }}
        ({{
          transactionState?.progressCount && transactionState?.totalCount
            ? (($safeNavigationMigration(transactionState?.progressCount) / $safeNavigationMigration(transactionState?.totalCount)) * 100 | number: '1.2-2')
            : 0
        }}
        %)
      </p>
      <mat-progress-bar
        [value]="calculateTransactionProcessPercentage(transactionState)"
        [mode]="mode"></mat-progress-bar>
    </div>
  }
</div>
